/**
 * @Author: Colin Osterhout <ctosterhout>
 * @Date:   2018-09-14T13:21:07-08:00
 * @Email:  ctosterhout@alaska.edu
 * @Last modified by:   ctosterhout
 * @Last modified time: 2020-02-17T22:13:33-09:00
 * @License: Released under MIT License. Copyright 2017 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
 */

// ----------------------------------------------------------------------------
// Import ACRC Landing theme
// ----------------------------------------------------------------------------
import '../scss/homepage.scss'

// ----------------------------------------------------------------------------
// Import common functionality
// ----------------------------------------------------------------------------
import {
  AcrcCommon,
  Vue
} from './common'

// ----------------------------------------------------------------------------
// JS Module imports
// ----------------------------------------------------------------------------

// ----------------------------------------------------------------------------
// Components particular to this template
// ----------------------------------------------------------------------------
import GoogleCalendar from 'ernie-core/components/GoogleCalendar'
import RandomMastheadImage from '../components/RandomMastheadImage'

const components = {
  GoogleCalendar: GoogleCalendar,
  RandomMastheadImage: RandomMastheadImage
}

// Initialize Ernie and then render all templates, passing in our own page-specific components.
Vue.use(AcrcCommon, {
  components: components
})

// Begin page render
AcrcCommon.render({
  disableScrollDown: true
})
